import { render, staticRenderFns } from "./multiHistogram.vue?vue&type=template&id=0c390dbc&"
import script from "./multiHistogram.vue?vue&type=script&lang=js&"
export * from "./multiHistogram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports